import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Box, Button, Typography } from '@mui/material';

import Utils from 'utils/Utils';

const posts = [
    {
        title: 'Notifications',
        description: 'Be informed and receive relevant daily \n vulnerabilities updates',
        image: 'landing/v2/tools/subscriptions',
        href: '/pricing'
    },
    {
        title: 'Linux Scanner',
        description: 'Use our free scanner to manage \n vulnerabilities on Linux based machines',
        image: 'landing/v2/tools/linux-scanner',
        href: '/pricing'
    },
    {
        title: 'Perimeter Scanner',
        description: 'Control your perimeter automatically with \n our new hosted vulnerability scanner',
        image: 'landing/v2/tools/perimeter-scanner',
        href: '/pricing'
    }
];

const useStyles = makeStyles()({
    root: {
        background: '#4D4DD7',
        '@media (max-width: 1140px)': {
            padding: 20
        }
    },
    boxButton: {
        '@media (max-width: 480px)': {
            width: '100%'
        }
    },
    underlay: {
        padding: '150px 40px',
        '@media (max-width: 1140px)': {
            padding: '60px 20px'
        },
        '@media (max-width: 480px)': {
            padding: '60px 0'
        }
    },
    header: {
        fontSize: 48,
        color: '#FAFAFA',
        '@media (max-width: 1140px)': {
            textAlign: 'left',
            marginBottom: 80
        }
    },
    box: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        maxWidth: 1180,
        margin: '120px auto 0',
        '@media (max-width: 1140px)': {
            marginTop: 40
        }
    },
    card: {
        width: 380,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
    },
    image: {
        paddingBottom: 40
    },
    title: {
        fontSize: 24,
        fontWeight: 600,
        paddingBottom: 24,
        color: '#FAFAFA'
    },
    description: {
        paddingBottom: 40,
        whiteSpace: 'pre',
        color: '#FAFAFA'
    },
    button: {
        fontSize: 16,
        padding: '16px 40px',
        borderRadius: 100,
        borderColor: '#e0e0e0',
        '@media (max-width: 1140px)': {
            marginBottom: 40
        },
        '@media (max-width: 480px)': {
            width: '100%'
        }
    }
});

const Blog = () => {
    const { classes } = useStyles();

    return (
        <Box className={classes.root}>
            <div className={classes.underlay}>
                <Typography className={classes.header} align="center" variant="h2">
                    {'Tools'}
                </Typography>

                <Box className={classes.box}>
                    {posts.map(({ title, description, image, href }, index) => (
                        <Box key={index} className={classes.card}>
                            <img src={Utils.getImage(image)} alt={title} className={classes.image} />
                            <Typography className={classes.title} variant="h3">
                                {title}
                            </Typography>
                            <Typography className={classes.description} variant="body2">
                                {description}
                            </Typography>
                            <Box textAlign="center" className={classes.boxButton}>
                                <Button
                                    href={href}
                                    target="_blank"
                                    variant="contained"
                                    color="inherit"
                                    className={classes.button}
                                >
                                    {'See Pricing'}
                                </Button>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </div>
        </Box>
    );
};

export default Blog;
